import type { PortalDsBadgeVariant } from 'src/components/portal-design-system';

export function surveyStatusPillVariant(status: string): PortalDsBadgeVariant {
  switch (status.toLowerCase()) {
    case 'live':
      return 'blue';
    case 'complete':
      return 'green';
    case 'review':
    case 'rejected':
    case 'failed':
      return 'red';
    case 'building':
      return 'amber';
    default:
      return 'gray';
  }
}
